// components/Loader.jsx
import React from "react";
import "./loader.css"; // Import CSS styles

export default function Loader() {
  return (
    <div className="loader-container">
      <div className="spinner"></div>
    </div>
  );
}
